import { render } from "./kaskoSlider.vue?vue&type=template&id=d70bdd02&scoped=true"
import script from "./kaskoSlider.vue?vue&type=script&lang=js"
export * from "./kaskoSlider.vue?vue&type=script&lang=js"

import "./kaskoSlider.vue?vue&type=style&index=0&id=d70bdd02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70bdd02"]])

export default __exports__